// extracted by mini-css-extract-plugin
export default {"imgdiv":"_6f81193d84 b39f37e212","img":"_48ed206c07 _96f4bbd317"};